/* Customdo — T&B Stationen-Akkordeon nach referenz-konfigurator.html (Handoff V4).
   Verhalten exakt wie die Referenz: genau eine Station offen (initial Station 1),
   Klick auf Kopf wechselt; Status „Offen"(gold) → „✓ Ausgefüllt"(grün) über das
   Pflichtfeld (erstes Input); ausgefüllter Wert klein im Kopf. T&B-Felder werden
   NUR umgehängt (appendChild), nie geklont — Events bleiben erhalten.
   FAIL-SAFE (Launch-Blocker-Garantie): Wenn nach dem Bau irgendeine Station leer ist
   oder keine Eingabe sichtbar wäre, wird alles zurückgebaut und das Akkordeon für
   diese Session deaktiviert — das flache T&B-Formular bleibt IMMER benutzbar.
   Not-Aus: localStorage.setItem('cdxWizardOff','1') + Reload, oder window.cdxWizardOff().
   V12: Laufzeit-Tagging/Gate entfernt — das T&B-Skin liefert cdx-tb-final.css/.js.
   Diagnose: window.cdxTbAudit(). */
(function () {
  'use strict';
  var MOUNT_SEL = '#teeinblue-form';
  var NUM_RE = /^\s*([1-9]\d?)\s*\./;
  /* Das Akkordeon darf NUR bei echten Orts-Stationen bauen. Vorher matchte die
     blosse Nummerierung — auch "1. Zeile"/"2. Zeile" einer Schnapsbank oder einer
     Weihnachtskugel wurden dann zu "Station 1"/"Station 2" bei Produkten ganz ohne
     Orte (Testergebnis 01.08.2026, Punkte 23 und 25).
     Geprueft wird auf GRUPPEN-Ebene, nicht je Label: Eine Station besteht aus
     mehreren Feldern, von denen nur eines nach Adresse klingt ("1. Adresse oder
     Koordinaten eingeben" + "1. Datum unter der Karte"). Verlangt wird deshalb:
     mindestens ein Label im gesamten Satz muss ortsbezogen sein. */
  var STATION_HINT_RE = /(adresse|koordinat|\bort\b|\borte\b|station|standort)/i;
  var SIZE_FRAME_RE = /^\s*(w[äa]hle eine gr[öo][ßs]+e|bilderrahmen)/i;
  // sichtbare, echte Eingaben — keine hidden/checkbox/radio (Status-Kriterium + Fail-safe)
  var REQ_SEL = 'input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]), textarea, select';

  /* MOBILE: Teeinblue rendert dort ein eigenes Layout (Overlay/Drawer). Das
     Umhängen der Felder in unsere Akkordeon-Karten kann die Bedienung dort
     unbrauchbar machen (Felder erscheinen gar nicht). Auf kleinen Screens
     bleibt deshalb das native T&B-Formular unangetastet — Funktion vor Optik.
     Override zum Testen: localStorage.setItem('cdxWizardMobile','1'). */
  function isMobile() {
    try { if (localStorage.getItem('cdxWizardMobile') === '1') return false; } catch (e) {}
    return window.innerWidth < 750;
  }
  function offManual() { try { return localStorage.getItem('cdxWizardOff') === '1'; } catch (e) { return false; } }
  function offAuto() { try { return sessionStorage.getItem('cdxWizardAuto') === '1'; } catch (e) { return false; } }
  function setOffAuto() { try { sessionStorage.setItem('cdxWizardAuto', '1'); } catch (e) {} }
  window.cdxWizardOff = function () { try { localStorage.setItem('cdxWizardOff', '1'); } catch (e) {} location.reload(); };

  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function ownText(el) {
    var t = '';
    for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) t += n.textContent;
    return (t || el.textContent || '').trim();
  }

  /* ---------- Stationen erkennen ---------- */
  function findLabelEls(mount) {
    return qsa('label, [class*="label"], [class*="title"], legend, p, span, div', mount).filter(function (el) {
      if (el.closest('.cd-station')) return false;
      if (el.children.length > 2) return false;
      var t = ownText(el);
      return t.length > 2 && t.length < 80 && NUM_RE.test(t);
    });
  }
  function deepestCommonAncestor(nodes, mount) {
    if (!nodes.length) return null;
    function chain(el) { var c = []; while (el && el !== mount) { c.unshift(el); el = el.parentElement; } return c; }
    var common = chain(nodes[0]);
    for (var i = 1; i < nodes.length; i++) {
      var c = chain(nodes[i]), j = 0;
      while (j < common.length && j < c.length && common[j] === c[j]) j++;
      common = common.slice(0, j);
      if (!common.length) return mount;
    }
    // der tiefste GEMEINSAME Vorfahr selbst (nicht dessen Parent!) — sonst wird der
    // ganze Formular-Container als ein einziger "Wrapper" verschoben (V4-Bug)
    return common.length ? common[common.length - 1] : mount;
  }
  function detectGroups(mount) {
    var labels = findLabelEls(mount);
    if (labels.length < 4) return null; // < 2 Stationen à 2 Felder
    // Ortsbezug im gesamten Satz verlangen — sonst ist es keine Stations-Struktur
    if (!labels.some(function (el) { return STATION_HINT_RE.test(ownText(el)); })) return null;
    var host = deepestCommonAncestor(labels, mount);
    if (!host) return null;
    var groups = new Map();
    labels.forEach(function (lab) {
      var w = lab;
      while (w.parentElement && w.parentElement !== host) w = w.parentElement;
      if (w.parentElement !== host) return;
      var m = NUM_RE.exec(ownText(lab));
      if (!m) return;
      var key = m[1];
      if (!groups.has(key)) groups.set(key, []);
      if (groups.get(key).indexOf(w) === -1) groups.get(key).push(w);
    });
    if (groups.size < 2) return null;
    return { host: host, groups: groups };
  }

  /* ---------- Bauen (Markup/Verhalten = Referenz) ---------- */
  function buildStationCard(n) {
    var card = document.createElement('div');
    card.className = 'cd-station';
    card.innerHTML =
      '<button type="button" class="cd-station-head">' +
      '<span class="cd-station-num">' + n + '</span>' +
      '<span class="cd-station-ttl">Station ' + n + '<span class="cd-station-sub"></span></span>' +
      '<span class="cd-station-state">Offen</span></button>' +
      '<div class="cd-station-body"></div>';
    return card;
  }
  function build(mount) {
    if (mount.querySelector('.cd-stations')) return true;
    var det = detectGroups(mount);
    if (!det) return false;
    var host = det.host, groups = det.groups;
    var keys = Array.from(groups.keys());

    // Rebuild-Hygiene — V10-korrigiert: Ein altes Feld (data-cdx-prev) wird NUR dann
    // als Zombie versteckt, wenn ein frisches Feld mit DEMSELBEN Label existiert
    // (echtes Duplikat). T&B erzeugt einfache Textfelder neu, persistente Komponenten
    // (Adress-Autocomplete!) aber nicht — die pauschale Regel hat das Pflicht-
    // Adressfeld ausgeblendet (V10-Regression 1).
    function wrapperLabel(el) {
      var labs = qsa('label, [class*="label"], legend, p, span, div', el);
      labs.unshift(el);
      for (var i = 0; i < labs.length; i++) {
        var t = ownText(labs[i]);
        if (t && NUM_RE.test(t)) return t.toLowerCase().replace(/\s+/g, ' ').slice(0, 60);
      }
      return null;
    }
    keys.forEach(function (n) {
      var list = groups.get(n);
      var fresh = list.filter(function (el) { return !el.hasAttribute('data-cdx-prev'); });
      if (!fresh.length) return;
      var freshLabels = fresh.map(wrapperLabel);
      var keep = list.filter(function (el) {
        if (!el.hasAttribute('data-cdx-prev')) return true;
        var lbl = wrapperLabel(el);
        if (lbl && freshLabels.indexOf(lbl) !== -1) { el.classList.add('cd-tb-stale'); return false; }
        return true; // persistentes Feld ohne frischen Zwilling → behalten
      });
      groups.set(n, keep);
    });

    var wrap = document.createElement('div');
    wrap.className = 'cd-stations';
    var firstEl = groups.get(keys[0])[0];
    firstEl.parentNode.insertBefore(wrap, firstEl);

    keys.forEach(function (n) {
      var card = buildStationCard(n);
      var body = card.querySelector('.cd-station-body');
      groups.get(n).forEach(function (el) { el.removeAttribute('data-cdx-prev'); body.appendChild(el); }); // unverändert umhängen
      wrap.appendChild(card);

      card.querySelector('.cd-station-head').addEventListener('click', function () {
        if (card.classList.contains('open')) return; // V4: GENAU EINE Station ist immer offen
        Array.prototype.forEach.call(wrap.children, function (c) { c.classList.remove('open'); });
        card.classList.add('open');
      });
      card.addEventListener('input', function () {
        var req = body.querySelector(REQ_SEL);
        var val = req ? (req.value || '').trim() : '';
        card.classList.toggle('done', !!val);
        card.querySelector('.cd-station-state').textContent = val ? '✓ Ausgefüllt' : 'Offen';
        card.querySelector('.cd-station-sub').textContent = val ? ' · ' + val.slice(0, 32) : '';
      });
    });
    if (wrap.firstChild) wrap.firstChild.classList.add('open'); // GENAU EINE Station offen

    // Größe/Rahmen UNTER die Stationen — NUR host-Kinder mit exakt passendem eigenen Label
    var after = wrap;
    Array.prototype.slice.call(host.children).forEach(function (child) {
      if (child === wrap || child.classList.contains('cd-station')) return;
      var labelEl = null;
      var cands = qsa('label, [class*="label"], [class*="title"], legend, p, span, div', child);
      cands.unshift(child);
      for (var i = 0; i < cands.length; i++) {
        var t = ownText(cands[i]);
        if (t && t.length < 60 && SIZE_FRAME_RE.test(t)) { labelEl = cands[i]; break; }
      }
      if (labelEl && child.contains(labelEl)) {
        movedChildren.push({ el: child, parent: child.parentNode, next: child.nextSibling });
        host.insertBefore(child, after.nextSibling);
        after = child;
      }
    });

    /* FAIL-SAFE: jede Station braucht >= 1 SICHTBARES Eingabefeld, sonst alles zurück */
    var ok = wrap.children.length >= 2 && Array.prototype.every.call(wrap.children, function (c) {
      var body = c.querySelector('.cd-station-body');
      return body && body.querySelector(REQ_SEL);
    });
    if (!ok) { teardown(mount); setOffAuto(); return false; }
    return true;
  }

  var movedChildren = []; // von build() umgestellte Größe/Rahmen-Blöcke (für teardown)
  function teardown(mount) {
    // V11-Merkregel: ALLE vom Theme injizierten Elemente vor dem Umbau entfernen —
    // sonst spült der Umbau sie aus den Stationen und sie stapeln sich davor (11×-Bug)
    qsa('.cd-tb-reqhint', mount).forEach(function (e) { e.parentNode && e.parentNode.removeChild(e); });
    var wrap = mount.querySelector('.cd-stations');
    if (wrap) {
      qsa('.cd-station-body', wrap).forEach(function (body) {
        while (body.firstChild) {
          if (body.firstChild.nodeType === 1) body.firstChild.setAttribute('data-cdx-prev', '1');
          wrap.parentNode.insertBefore(body.firstChild, wrap);
        }
      });
      wrap.parentNode.removeChild(wrap);
    }
    // Größe/Rahmen an ihre Ursprungsposition zurück
    movedChildren.forEach(function (m) {
      try {
        if (m.next && m.next.parentNode === m.parent) m.parent.insertBefore(m.el, m.next);
        else m.parent.appendChild(m.el);
      } catch (e) {}
    });
    movedChildren = [];
  }

  /* F2: Status auch bei programmatisch gesetzten Werten (Adress-Picker) aktuell halten.
     Schreiben NUR bei Änderung — der textContent-Setter erzeugt sonst im 900ms-Takt
     childList-Mutationen und damit eine ewige Retag-Schleife (Verify-Fund). */
  function updateStatuses(mount) {
    // V12: Pflicht-Hinweise erzeugt/räumt jetzt ausschließlich cdx-tb-final.js
    // (.cd-required-hint). Altbestand aus früheren Deploys hier einmal wegräumen.
    qsa('.cd-tb-reqhint', mount).forEach(function (e) { e.parentNode && e.parentNode.removeChild(e); });
    qsa('.cd-station', mount).forEach(function (card) {
      var body = card.querySelector('.cd-station-body');
      // V14: Hat die Station einen Adress-Trigger, besitzt cdx-tb-final.js den
      // Status (echter Adresswert). Zwei Schreiber = Flackern + falsches Grün.
      if (card.querySelector('.cd-address-trigger')) return;
      var req = body ? body.querySelector(REQ_SEL) : null;
      var val = req ? (req.value || '').trim() : '';
      var done = !!val;
      card.classList.toggle('done', done);
      var st = card.querySelector('.cd-station-state');
      var stTxt = done ? '✓ Ausgefüllt' : 'Offen';
      if (st && st.textContent !== stTxt) st.textContent = stTxt;
      var sub = card.querySelector('.cd-station-sub');
      var subTxt = done ? ' · ' + val.slice(0, 32) : '';
      if (sub && sub.textContent !== subTxt) sub.textContent = subTxt;
      // V10-Failsafe: Pflichtfeld einer OFFENEN Station muss sichtbar sein — wenn nicht,
      // Verstecker in dieser Station zurücknehmen (stale auf Input-Trägern)
      if (body && card.classList.contains('open') && (!req || req.offsetHeight === 0)) {
        qsa('.cd-tb-stale', body).forEach(function (el) {
          if (el.tagName === 'INPUT' || el.querySelector('input, textarea, select')) {
            el.classList.remove('cd-tb-stale');
          }
        });
      }
    });
  }

  /* DOM-Dump nach V8-Rezept — Konsole: cdxTbDump() (optional: cdxTbDump('Straßenname')).
     1) Adressfeld: tiefstes Element, das den eingetippten Stations-Wert enthält, + Parent.
     2) Chip-Eltern-Kette: die 4 Hüllen über der ersten .tee-radio (zeigt das beige Panel). */
  window.cdxTbDump = function (needle) {
    var mount = document.querySelector(MOUNT_SEL);
    if (!mount) { console.log('cdxTbDump: kein #teeinblue-form'); return; }
    if (!needle) {
      var req = mount.querySelector('.cd-station-body ' + REQ_SEL) || mount.querySelector(REQ_SEL);
      needle = req && (req.value || '').trim().slice(0, 20);
    }
    var addrOut = '(keine Adresse gefunden — erst eine Station ausfüllen, dann cdxTbDump() erneut)';
    if (needle) {
      var hit = qsa('*', document.body).filter(function (e) {
        return e.children.length <= 3 && (e.textContent || '').indexOf(needle) !== -1;
      }).slice(-1)[0];
      if (hit && hit.parentElement) addrOut = hit.parentElement.outerHTML.slice(0, 2500);
    }
    var chainOut = '(keine .tee-radio gefunden)';
    var radio = mount.querySelector('.tee-radio');
    if (radio) {
      var p = radio.parentElement, parts = [];
      for (var i = 0; i < 4 && p; i++) { parts.push(p.cloneNode(false).outerHTML); p = p.parentElement; }
      chainOut = parts.join('\n');
    }
    var out = '=== 1) ADRESSFELD (Element + Parent, Suchwort: ' + (needle || '-') + ') ===\n' + addrOut +
      '\n\n=== 2) DIE 4 ELTERN-HÜLLEN DES CHIPS (Panel-Kandidaten) ===\n' + chainOut;
    console.log(out);
    try { window.copy && window.copy(out); } catch (e) {}
    return out;
  };

  /* ---------- Diagnose ---------- */
  window.cdxTbAudit = function () {
    var mount = document.querySelector(MOUNT_SEL);
    if (!mount) { console.log('cdxTbAudit: kein #teeinblue-form'); return; }
    var report = {
      wizardManualOff: offManual(), wizardAutoOff: offAuto(),
      stations: qsa('.cd-station', mount).length,
      openStations: qsa('.cd-station.open', mount).length,
      emptyStations: qsa('.cd-station', mount).filter(function (c) { return !c.querySelector('.cd-station-body input,.cd-station-body textarea,.cd-station-body select'); }).length,
      staleHidden: qsa('.cd-tb-stale', mount).length,
      /* V12-Drop-in (cdx-tb-final.js/.css) */
      teeRadios: qsa('.tee-radio', mount).length,
      teeRadiosActive: qsa('.tee-radio.active', mount).length,
      addressTriggers: qsa('.cd-address-trigger', mount).length,
      addressFilled: qsa('.cd-address-trigger.cd-filled', mount).length,
      pins: qsa('.cd-pin', mount).length,
      hints: qsa('.cd-required-hint', mount).length,
      hintsOutsideStations: qsa('.cd-required-hint', mount).filter(function (h) { return !h.closest('.cd-station'); }).length
    };
    console.log('cdxTbAudit:', JSON.stringify(report, null, 2));
    return report;
  };

  /* ---------- Boot ---------- */
  function start() {
    var mount = document.querySelector(MOUNT_SEL);
    if (!mount) return;
    /* Mobile war frueher ausgenommen, weil dort scheinbar unser Code den
       Konfigurator zerlegte. Die tatsaechliche Ursache war eine CSS-Regel, die
       Teeinblues Einblende-Animation abgeschaltet hat (inzwischen geloescht).
       Damit gibt es keinen Grund mehr, Mobile anders zu behandeln — und dort ist
       "eine Station nach der anderen" sogar wichtiger als am Desktop. */
    if (isMobile()) document.documentElement.classList.add('cdx-tb-mobile');
    var t = null, rebuilds = 0;
    function run() {
      (function () {
        try {
          if (offManual() || offAuto()) return;
          var built = mount.querySelector('.cd-stations');
          if (!built) {
            build(mount);
            return;
          }
          // T&B hat neu gerendert (Anzahl-Orte-Wechsel): nummerierte Felder außerhalb
          if (findLabelEls(mount).length >= 4 && rebuilds < 12) {
            rebuilds++;
            // V10: Layout-Shift dämpfen — Höhe während des Umbaus halten, kein Springen
            var holdH = mount.offsetHeight;
            if (holdH > 0) mount.style.minHeight = holdH + 'px';
            teardown(mount);
            build(mount);
            setTimeout(function () { mount.style.minHeight = ''; }, 350);
          }
        } catch (e) {
          try { teardown(mount); } catch (e2) {}
          setOffAuto(); // im Zweifel: flaches, funktionierendes Formular
        }
      })();
    }
    var mo = new MutationObserver(function (muts) {
      var foreign = muts.some(function (m) {
        var inOurs = m.target && m.target.closest && m.target.closest('.cd-stations');
        if (!inOurs) return true;
        // innerhalb unserer Stationen zählen nur ELEMENT-Zugänge (T&B rendert nach);
        // reine Textknoten-Mutationen (unsere Status-Schreiber) lösen nichts aus
        return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1; });
      });
      if (!foreign) return;
      clearTimeout(t); t = setTimeout(run, 700);
    });
    mo.observe(mount, { childList: true, subtree: true });
    if (mount.children.length) t = setTimeout(run, 900);
    // F2: Poll + change-Capture, damit auch Adress-Picker-Werte den Status setzen
    mount.addEventListener('change', function () { updateStatuses(mount); }, true);
    var pollId = setInterval(function () {
      if (offManual() || offAuto()) { clearInterval(pollId); return; }
      if (mount.querySelector('.cd-stations')) updateStatuses(mount);
    }, 900);
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
